import React, { Component } from "react";
import { connect } from "react-redux";
import { emptyWishlist } from "../actions/cartActions";
import WishlistLine from './WishlistLine';
import { withTranslation } from 'react-i18next';


class Wishlist extends Component {

    onEmptyWishlist = e => {
        this.props.emptyWishlist();
    };

    render() {
        const { t, wishlist, settings } = this.props;
        if (!wishlist || wishlist.length === 0)
            return (<div className="alert alert-info fade show text-center margin-bottom-1x">
                <span className="alert-close" data-dismiss="alert"></span>
                <i className="icon-layers"></i>&nbsp;&nbsp;<strong>{t("My Wishlist")}:</strong> {t("You don't have any products in your wishlist")}.
                </div>);


        var wishlistLines = wishlist.map(line => {
            return (
                <WishlistLine
                    key={line.id}
                    line={line}
                    settings={settings}
                />
            );
        });

        return (
            <div className="table-responsive wishlist-table margin-bottom-none">
                <table className="table ">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="text-center">
                                <a  href={null} role="button" onClick={this.onEmptyWishlist} className="btn btn-sm btn-outline-danger">
                                    {t("Clear Wishlist")}
        </a>
                            </th>
                        </tr>
                    </thead>
                    <tbody>{wishlistLines}</tbody>
                </table>
            </div>
        );
    }
}

function mapStateToProps({  wishlist, settings }, ownProps) {
    return {wishlist, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, { emptyWishlist })(Wishlist));
